import { ViewportScroller } from '@angular/common';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../environments/environment';
import { FetchDataService } from './shared/services/fetch-data.service';
import { style } from '@angular/animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  language!: string;
  whatsApp: any = {
    path: '',
    link: '',
  };

  constructor(
    private router: Router,
    private translate: TranslateService,
    private viewportScroller: ViewportScroller,
    private titleService: Title,
    private fetchDataService: FetchDataService,

    private route: ActivatedRoute
  ) {
    this.whatsApp.path =
      '../../../assets/' + environment.projectName + '/icons/whatsapp-logo.png';
    this.titleService.setTitle(environment.projectName.replace('-', ' '));
    const link: HTMLLinkElement = document.querySelector(
      "link[rel*='icon']"
    ) as HTMLLinkElement;
    if (link) {
      link.href =
        './assets/' + environment.projectName + '/media/header/logo.png';
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.language = this.router.url.split('/')[1];
        this.translate.setDefaultLang(this.language);
      }
    });
    this.fetchDataService.loadStyles().subscribe({
      next: (style: any) => {
        this.applyStyles(style);
      },
      error: (err) => {
        console.error('Error fetching styles:', err);
      },
    });
    this.fetchDataService.getSocialLinkes().subscribe({
      next: (data: any) => {
        this.whatsApp.link = data.soicalMediaLinks.find(
          (item: any) => item.name === 'whatsapp'
        ).link;
      },
      error: (err) => {
        console.error('Error fetching services:', err);
      },
    });
  }
  ngAfterViewInit() {
    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        setTimeout(() => {
          const element = document.getElementById(fragment);
          if (element) {
            const yOffset = 100;
            const y =
              element.getBoundingClientRect().top + window.scrollY - yOffset;
            window.scrollTo({ top: y });
          }
        }, 300);
      }
    });
  }
  applyStyles(selectedStyles: any) {
    Object.entries(selectedStyles).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value as string);
    });
  }

  title = 'GenAI-Agency';
}
